import React, { forwardRef, useEffect, useRef } from 'react'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import SpinButton from '../components/SpinButton'
import style from './ItemPreview.module.scss'
import commonStyle from '../common.module.scss'
import { hapticEffects } from '@aytm/app/swidget/base/lib/hapticEffects'
import { IEcommerceAnswerResponse } from '../../types'

interface IProductActionsProps {
  isMobile: boolean
  response: IEcommerceAnswerResponse
  findability: boolean
  index: number
  limit?: number
  onProductAction: (qnt: 1 | -1, index: string, subscribe?: number) => void
  onSpin: (event: React.KeyboardEvent, index: string, subscribe?: number) => void
}

const ProductActions = forwardRef<HTMLDivElement, IProductActionsProps>((props, ref) => {
  const { isMobile, response, findability, onProductAction, onSpin, limit } = props
  const buttonRef = useRef<HTMLButtonElement>(null)
  const firstRenderRef = useRef<boolean>(true)
  const { t } = useSurveyLocale()

  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false
    } else {
      if (ref && 'current' in ref && ref.current && response && 1 === response.v) {
        ref.current.focus()
      } else if (!response || (response && 0 === response?.v && buttonRef.current)) {
        buttonRef.current.focus()
      }
    }
  }, [response, ref])

  const addToCartButton = (
    <button
      ref={buttonRef}
      className={isMobile ? style.addMobile : commonStyle.add}
      onClick={event => {
        event?.stopPropagation()
        hapticEffects.selection()
        onProductAction(1, response?.id || '', response?.subscribe)
      }}
      disabled={response?.v > 0}
    >
      {t('questions', 'ec', 'amazon', 'addToCart')}
    </button>
  )

  const spinButton = (
    <SpinButton
      ref={ref}
      styles={isMobile ? { marginTop: '4px', width: '125px' } : { marginTop: '8px', width: '105px' }}
      value={response?.v || 0}
      index={response?.id || ''}
      limit={limit}
      onClick={(qnt: 1 | -1, index: string) => onProductAction(qnt, index, response?.subscribe)}
      onSpin={(event: React.KeyboardEvent, index: string) => onSpin(event, index, response?.subscribe)}
    />
  )

  return !response || (response && 0 === response?.v) || findability ? addToCartButton : spinButton
})

ProductActions.displayName = 'ProductActions'

export default ProductActions
